import axios from '../../axios'

/*
 * 定时任务数据接口
 */

// 定时任务列表
export const getQuartzList = (data) => {
    return axios({
        url: '/api/sys/job/quartz',
        method: 'get',
        data
    })
}

// 新增调度任务
export const saveQuartz = (data) => {
    return axios({
        url: '/api/sys/job/add_job',
        method: 'post',
        data
    })
}

// 修改调度任务
export const updateQuartz = (data) => {
    return axios({
        url: '/api/sys/job/update_job',
        method: 'put',
        data
    })
}

// 暂停所有调度任务
export const pauseAllQuartz = (data) => {
    return axios({
        url: '/api/sys/job/pause_all',
        method: 'put',
        data
    })
}

// 暂停调度任务
export const pauseQuartz = (data) => {
    return axios({
        url: '/api/sys/job/pause_job',
        method: 'put',
        data
    })
}

// 恢复调度任务
export const resumeAllQuartz = (data) => {
    return axios({
        url: '/api/sys/job/resume_all',
        method: 'put',
        data
    })
}

// 恢复调度任务
export const resumeQuartz = (data) => {
    return axios({
        url: '/api/sys/job/resume_job',
        method: 'put',
        data
    })
}

// 删除调度任务
export const deleteQuartz = (data) => {
    return axios({
        url: '/api/sys/job/delete_job ',
        method: 'delete',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/quartz.js